// Clone value
const clone = document.getElementById("selected-value-clone"),
  cloneText = clone.textContent,
  cloned = document.getElementById("cloned-info");

cloned.textContent = cloneText;

// Hide #cloned-info when it only contains a screen size (no letters = numeric size like 15.6")
// global.js sets #cloned-info directly on every option change, so we watch for those changes too
function updateClonedInfoVisibility() {
  var text = cloned.textContent.trim();
  cloned.style.display = /[a-zA-Z]/.test(text) ? '' : 'none';
}
updateClonedInfoVisibility();

new MutationObserver(updateClonedInfoVisibility).observe(cloned, {
  childList: true, characterData: true, subtree: true
});

// Clone price
function clonePrice() {
  let wrapper = document.querySelector("#product-detail"),
    clonePrice = wrapper.querySelector("#main-price"),
    clonePriceClass = clonePrice.classList,
    clonePriceHTML = clonePrice.innerHTML,
    clonedPrice = document.getElementById("cloned-price");

  clonedPrice.className = clonePriceClass;
  clonedPrice.innerHTML = clonePriceHTML;
}
clonePrice();

// Sync the sticky image src from the currently active main gallery image
function syncStickyImage() {
  var stickyImg = document.getElementById('sticky-product-image');
  if (!stickyImg) return;
  var mainActive = document.querySelector('#product-detail .product__media-wrapper .product__media-item.is-active img')
                || document.querySelector('#product-detail .product__media-wrapper .product__media-item img');
  if (mainActive && mainActive.src) {
    stickyImg.src = mainActive.src;
  }
}


// React to variant changes fired by product-info.js
var productInfo = document.querySelector('product-info');
if (productInfo) {
  productInfo.addEventListener('change', function(e) {
    if (e.target.name !== 'id') return;
    var newVariantId = e.target.value;

    // 1. Keep the sticky Add to Cart in sync with the selected variant
    var stickyInput = document.querySelector('#sticky-info input[name="id"]');
    if (stickyInput) stickyInput.value = newVariantId;

    // 2. Re-clone the price
    clonePrice();

    // 4. Sync image after main gallery has updated
    setTimeout(syncStickyImage, 150);
  });
}

// Track scroll
window.addEventListener("scroll", function () {
  const elementTarget = document.getElementById("buy-btn-tracker"),
    stickyEle = document.getElementById("sticky-info"),
    wrapper = document.getElementById("MainContent");

  if (
    window.scrollY > elementTarget.offsetTop + elementTarget.offsetHeight &&
    wrapper.getBoundingClientRect().bottom >
      stickyEle.getBoundingClientRect().bottom
  ) {
    stickyEle.classList.add("show");
  } else {
    stickyEle.classList.remove("show");
  }
});
